import React, { useContext } from "react";
import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  Stack,
  Typography,
  CardActions,
  Button,
} from "@mui/material";
import { Link } from "react-router-dom";
import { userContext } from "../../Context";

export default function ProjectCard({
  id,
  placeholderImg,
  name,
  type,
  overview,
  canClaim,
  handleClickProject,
  handleMouseLeaveProject,
}) {
  const { user } = useContext(userContext);

  return (
    <Grid item xs={12} md={6} lg={6}>
      <Card
        onClick={() => handleClickProject(id)}
        onMouseEnter={() => handleClickProject(id)}
        onMouseLeave={() => handleMouseLeaveProject(id)}
      >
        <CardMedia
          component="img"
          height="140"
          src={placeholderImg}
          alt="Gray placeholder"
        />
        <CardContent>
          <Grid container alignItems="center" pb={2}>
            <Grid item xs={11}>
              <Stack>
                <Typography
                  variant="h6"
                  component="div"
                  whiteSpace="nowrap"
                  textOverflow="ellipsis"
                  display="block"
                  overflow="hidden"
                >
                  {name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {type ? type : "No project type"}
                </Typography>
              </Stack>
            </Grid>
          </Grid>

          <Typography variant="body2" color="text.secondary" minHeight={42}>
            {overview ? (
              <>
                {overview.length > 50
                  ? `${overview.slice(0, 50)}...`
                  : overview}
              </>
            ) : (
              "No Overview"
            )}
          </Typography>
        </CardContent>
        <CardActions>
          <Button color="primary" variant="contained">
            <Link
              to={`/project/${id}`}
              state={{ id: id }}
              style={{
                color: "#FFFFFF",
                textDecoration: "none",
              }}
            >
              View Project
            </Link>
          </Button>
          <Button color="primary" disabled={!canClaim} variant="contained">
            <Link
              to={
                user.role === "" ||
                user.role === "Support" ||
                user.role === null
                  ? "/join"
                  : `/claim/${id}`
              }
              state={{ id: id }}
              style={{
                color: "#FFFFFF",
                textDecoration: "none",
              }}
            >
              {canClaim ? (
                <>Claim Project</>
              ) : (<>Claimed</>)}
            </Link>
          </Button>
        </CardActions>
      </Card>
    </Grid>
  );
}
